import { render } from "./publicDoc.vue?vue&type=template&id=529db50f&scoped=true"
import script from "./publicDoc.vue?vue&type=script&lang=js"
export * from "./publicDoc.vue?vue&type=script&lang=js"

import "./publicDoc.vue?vue&type=style&index=0&id=529db50f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529db50f"]])

export default __exports__